// Resource notes client — team alerts on rigs and technicians.

import { manufacturingFetch } from "@/lib/manufacturingClient";
import type { ServiceResourceNote } from "./types";

type OrgEnvelope = { ok: true; organization_id: string };

export function listServiceResourceNotes() {
  return manufacturingFetch<OrgEnvelope & { notes: ServiceResourceNote[] }>(
    "/api/service/resource-notes",
    { method: "GET" }
  );
}

export function upsertServiceResourceNote(payload: {
  id?: string;
  resource_type: "rig" | "tech";
  resource_id: string;
  body: string;
  expires_on?: string | null;
}) {
  return manufacturingFetch<OrgEnvelope & { note: ServiceResourceNote }>(
    "/api/service/resource-notes/upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}

export function dismissServiceResourceNote(noteId: string) {
  return manufacturingFetch<{ ok: true }>("/api/service/resource-notes/dismiss", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ note_id: noteId }),
  });
}
